import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import ShapeCornerRight from "../ShapeContainer/ShapeCornerRight";

const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    color: ${({ theme }) => theme.colors.blue.toString()};
    white-space: normal;
    background-color: transparent;
    border-radius: 20px;

    /* Fix for border-radius with overflow for safari */
    transform: translateZ(0);
`;

const textContainer = css`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100px;
    padding: 10px 20px 20px;
`;

const BackgroundContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
`;

const FillTopContainer = styled.div`
    flex: 1;
    width: 100%;
`;

const BottomContainer = styled.div`
    display: flex;
    width: 100%;
`;

const FillLeftContainer = styled.div`
    flex: 1;
`;

const ShapeContainer = styled.div`
    display: flex;
    align-self: stretch;
    height: auto;

    svg {
        width: auto;
        height: auto;
    }
`;

const ImageContainer = styled.div`
    z-index: 1;
`;

const TextContainer = ({ children, ...props }) => {
    return (
        <div css={textContainer} {...props}>
            {children}
        </div>
    );
};

const SmallShapeContainer = ({ children, color = "#f0f0f0", ...props }) => {
    return (
        <Container {...props}>
            {children}
            <BackgroundContainer>
                <FillTopContainer
                    css={css`
                        background-color: ${color};
                    `}
                />
                <BottomContainer>
                    <FillLeftContainer
                        css={css`
                            background-color: ${color};
                        `}
                    />
                    <ShapeContainer>
                        <ShapeCornerRight color={color} />
                    </ShapeContainer>
                </BottomContainer>
            </BackgroundContainer>
        </Container>
    );
};

SmallShapeContainer.ImageContainer = ImageContainer;
SmallShapeContainer.ImageContainer.displayName = "ImageContainer";

SmallShapeContainer.TextContainer = TextContainer;
SmallShapeContainer.TextContainer.displayName = "TextContainer";

export default SmallShapeContainer;
